import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-logo-vercel",
  "use": "icon-logo-vercel-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-logo-vercel\"><title>Logo Vercel</title><path fill-rule=\"evenodd\" d=\"M256 48l240 416H16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol